import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIconModule } from '@angular/material/icon';
import { TruncatePipeModule } from '@app/app/pipes/truncate/truncate-pipe.module';
import { notificationTypeTransformer } from '../../notification-helpers';
import moment from 'moment';

@Component({
  selector: 'grid-activity-cell',
  imports: [
    MatIconModule,
    TruncatePipeModule
  ],
  templateUrl: './name-cell.component.html'
})
export class NameCellComponent implements ICellRendererAngularComp {
    public name: string;
    public borrowerName: string;
    public activityType: string;
    public created: string;
    public params: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
      this.params = params;
      this.borrowerName = this.params.data.borrowerName;
      this.activityType = notificationTypeTransformer(this.params.data.activityType);
      this.created = this.formatTimestamp(this.params.data.createdTimestamp);
      
    }

    value(): string {
      return this.params.value;
    }

    refresh(params: ICellRendererParams) {
      return false;
    }

    formatTimestamp(dateStamp: number) {
      return moment.unix(dateStamp).fromNow()
  }
}
